import { Component, OnInit, Input, Output, ViewChild, SimpleChanges, EventEmitter, Injectable, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { TagMatch, TimeSeriesDetail } from "../../models/dashboard";
import { isNil } from 'lodash';
import { DataService, SiteTypeService } from 'src/api/services';
import { SearchItem, SearchSource, SiteTwin, SiteType } from 'src/api/models';

@Component({
    selector: 'app-uri-select',    
    templateUrl: './uri-select.component.html',
    styleUrls: ['./uri-select.component.css']   
})
export class UriSelectComponent implements OnInit {
    //@ViewChild(NgbDropdown, { static: false }) dropdown: NgbDropdown;

    //todo: make this work
    // when a site type code is set, the behaviour will require a unit type and units tag to be selected
    // if one is not set (and enableTagMatch is true) then you will need to select a siteType from the list, and then define what meta tags you want to match on
    // this will result in a list of time series that match the site type and tag matches.
    @Input() siteType: string | null = null;

    @Input() enableTagMatch: boolean = false;
    @Input() enableMultiSelect: boolean = false;
    @Input() enableMediaSearch: boolean = false;
    @Input() enableTimeSeriesSearch: boolean = true;

    @Input() timeSeriesDetail: TimeSeriesDetail;
    siteTypeTagMatch: TagMatch;
    //metaTagMatch: TagMatch;
    //metaTagMatch2: TagMatch;
    unitTagMatch: TagMatch;
    unitTypeTagMatch: TagMatch;
    newTagMatch: TagMatch = { tagName: '', tagValue: '' } as TagMatch;

    @Input() siteTypeCode: string;
    @Input() siteUri: string | null = null;


    @Input() filter: string;
    @Input() type: string;
    @Input() showVirtuals: boolean = true;
    @Input() customerId: number;
    @Output() valueChange = new EventEmitter<any>();
    @Output() uriChange = new EventEmitter<any>();
    searching: boolean = false;

    inputType: string = "TimeSeries";
    showTagMatch: boolean = false;
    siteTwin: SiteTwin;

    searchResults: SearchSource[] = [];

    constructor(private dataService: DataService, private siteTypeService: SiteTypeService) {
    }

    ngOnInit() {
        if (this.timeSeriesDetail){
            this.inputType = this.timeSeriesDetail.sourceType;
            this.filter = this.timeSeriesDetail.uri;
            this.showTagMatch = this.timeSeriesDetail.tagMatches != null && this.timeSeriesDetail.tagMatches.length > 0;
        }
        
        if (this.enableTimeSeriesSearch) {
            this.inputType = "TimeSeries";
        } else if (this.enableMediaSearch) {
            this.inputType = "Media";
        }
        if (this.showTagMatch){
            this.unitTagMatch = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'units');
            this.unitTypeTagMatch = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'unitType');
            if (this.siteUri != null) {
                this.populateTagList();
            }
        }
        if (this.enableMultiSelect && this.siteUri == null && this.showTagMatch){
            //debugger;
            if (this.timeSeriesDetail.tagMatches == null){
                this.timeSeriesDetail.tagMatches = [];
            }
            const metaTagMatches = this.timeSeriesDetail.tagMatches?.filter(tm => tm.tagName != 'siteType');// && tm.tagName != 'units' && tm.tagName != 'unitType');

            this.siteTypeTagMatch = this.timeSeriesDetail.tagMatches?.find(tm => tm.tagName === 'siteType');
            if (this.siteTypeTagMatch == null){
                this.siteTypeTagMatch = { tagName: 'siteType', tagValue: '' } as TagMatch;
                this.timeSeriesDetail.tagMatches.push(this.siteTypeTagMatch);
            }
            
            
            /*if (metaTagMatches == null || metaTagMatches.length == 0){
                this.metaTagMatch = { tagName: '', tagValue: '' } as TagMatch;
                this.timeSeriesDetail.tagMatches.push(this.metaTagMatch);
            } 
            else {
                this.metaTagMatch = metaTagMatches[0];
            }
            if (metaTagMatches != null && metaTagMatches.length > 1)  {
                this.metaTagMatch2 = metaTagMatches[1];
            } else {
                this.metaTagMatch2 = { tagName: '', tagValue: '' } as TagMatch;
                this.timeSeriesDetail.tagMatches.push(this.metaTagMatch);
            }*/
           
            this.populateSiteTypeList();
        }
    }


    // save the current search as the URI that you want to select
    saveSearchAsUri(){
        this.timeSeriesDetail.uri = this.filter;
        this.timeSeriesDetail.sourceType = this.inputType;
    }

    doSearch() {
        this.searching = true;
        this.searchResults = null;
        this.dataService.DataSearch({
                customerId: this.customerId, 
                type: this.inputType, 
                search: this.filter, searchSize: 10, pageIndex: 0, 
                includeAlarms: false, 
                filterOld: true}).subscribe(r => {
            console.log(r);
            this.searchResults = r;

            this.searching = false;
        });
    }

    siteTypes: SiteType[];
    populateSiteTypeList(){  
        console.log("Populate Site Type List");
        this.siteTypeService.SiteTypeGetAll(this.customerId)
        .subscribe(site => {    
            this.siteTypes = site;
        });
    }

    unitTypes: string[] = [];
    units: string[] = [];
    populateTagList(){
        if (this.unitTypes == null || this.units == null || this.unitTypes.length == 0 || this.units.length == 0) {
            if (this.siteUri == null){
                /*this.siteTypeService.SiteTypeSearch({ customerId: this.customerId, type: this.siteTypeTagMatch.tagValue, searchSize:1, pageIndex: 0, filterOld:true } as SiteTypeService.SiteTypeSearchParams).subscribe(siteTypes => {
                    var site = siteTypes[0];
                    // loop through all the parameters and then all the metaTags and then create a unique list of the tagName and tagValue
                    const tagMatches: TagMatch[] = [];
                    if (site && site.parameters) {
                        for (const key in site.parameters) {
                            const unitType = site.parameters[key].unitType;
                            const units = site.parameters[key].units;
                            if (unitType && !this.unitTypes.includes(unitType)) {
                                this.unitTypes.push(unitType);
                            }
                            if (units && !this.units.includes(units)) {
                                this.units.push(units);
                            }
                        }
                    }
                });*/
            }
            else {
                this.siteTypeService.SiteTypeGetSiteUsingCode({customerId: this.customerId, siteUri: this.siteUri, siteTypeCode: this.siteTypeCode }).subscribe(site => {    
                    this.siteTwin = site;
                    // loop through all the parameters and then all the metaTags and then create a unique list of the tagName and tagValue
                    const tagMatches: TagMatch[] = [];
                    if (site && site.parameters) {
                        for (const key in site.parameters) {
                            const unitType = site.parameters[key].unitType;
                            const units = site.parameters[key].units;
                            if (unitType && !this.unitTypes.includes(unitType)) {
                                this.unitTypes.push(unitType);
                            }
                            if (units && !this.units.includes(units)) {
                                this.units.push(units);
                            }
                        }
                    }
                });
            }
        }
    }

    select(item: SearchItem, site: SearchSource){
        if (isNil(item)) {
            return;
        }
        this.timeSeriesDetail.uri = item.uri;
        this.timeSeriesDetail.virtualTimeSeriesId = item.virtualTimeSeriesId;
        //this.timeSeriesDetail.siteUri = site.siteUri;
        this.timeSeriesDetail.sourceType = site.type;
    }

    selectUnits(units: string){
        if (this.timeSeriesDetail == null){
            this.timeSeriesDetail = new TimeSeriesDetail();
            this.timeSeriesDetail.tagMatches = [];
        }
        if (this.timeSeriesDetail.tagMatches == null){
            this.timeSeriesDetail.tagMatches = [];
        }
        // Find if a TagMatch with tagName 'units' exists
        const existing = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'units');
        if (existing) {
            existing.tagValue = units;
        } else {
            this.timeSeriesDetail.tagMatches.push({ tagName: 'units', tagValue: units } as TagMatch);
        }
        /*this.unitTagMatch = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'unitType');
        if (this.unitTagMatch) {
            this.unitTagMatch.tagValue = units;
        } else {
            this.unitTagMatch = { tagName: 'unitType', tagValue: units } as TagMatch
            this.timeSeriesDetail.tagMatches.push(this.unitTagMatch);
        }*/
     
    }

    selectUnitType(unitType: string){
        if (this.timeSeriesDetail == null){
            this.timeSeriesDetail = new TimeSeriesDetail();
            this.timeSeriesDetail.tagMatches = [];
        }
        if (this.timeSeriesDetail.tagMatches == null){
            this.timeSeriesDetail.tagMatches = [];
        }
        // Find if a TagMatch with tagName 'units' exists
        
        this.unitTypeTagMatch = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'unitType');
        if (this.unitTypeTagMatch) {
            this.unitTypeTagMatch.tagValue = unitType;
        } else {
            this.unitTypeTagMatch = { tagName: 'unitType', tagValue: unitType } as TagMatch
            this.timeSeriesDetail.tagMatches.push(this.unitTypeTagMatch);
        }
    }

    selectSiteType(siteType: string){
        if (this.timeSeriesDetail == null){
            this.timeSeriesDetail = new TimeSeriesDetail();
            this.timeSeriesDetail.tagMatches = [];
        }
        if (this.timeSeriesDetail.tagMatches == null){
            this.timeSeriesDetail.tagMatches = [];
        }
        // Find if a TagMatch with tagName 'units' exists
        
        this.siteTypeTagMatch = this.timeSeriesDetail.tagMatches.find(tm => tm.tagName === 'siteType');
        if (this.siteTypeTagMatch) {
            this.siteTypeTagMatch.tagValue = siteType;
        } else {
            this.siteTypeTagMatch = { tagName: 'siteType', tagValue: siteType } as TagMatch
            this.timeSeriesDetail.tagMatches.push(this.siteTypeTagMatch);
        }

        this.unitTypes = [];
        this.units = [];
        //this.populateTagList();
    }

    addTagMatch(){
        if (this.timeSeriesDetail.tagMatches == null){
            this.timeSeriesDetail.tagMatches = [];
        }   
        this.timeSeriesDetail.tagMatches.push(this.newTagMatch);
        this.newTagMatch = { tagName: '', tagValue: '' } as TagMatch;
    }

    removeTagMatch(tagMatch: TagMatch){
        const index = this.timeSeriesDetail.tagMatches.indexOf(tagMatch);
        if (index > -1) {
            this.timeSeriesDetail.tagMatches.splice(index, 1);
        }
    }

    toggleTagMatch(state: boolean) {
        this.showTagMatch = state;
        //alert("Tag Match is not implemented yet. Please use the tag match in the time series detail editor.");
        if (this.showTagMatch) {
            this.timeSeriesDetail.uri = null;
            this.timeSeriesDetail.siteUri = null;
            this.populateTagList();
            this.populateSiteTypeList();
        }else{
            this.timeSeriesDetail.tagMatches = [];
            this.timeSeriesDetail.siteUri = null;
            //this.metaTagMatch = null;
            //this.metaTagMatch2 = null;
            this.unitTagMatch = null;
            this.unitTypeTagMatch = null;
            this.siteTypeTagMatch = null;
        }
    }
    
}
